import { createContext, useContext } from "react";

interface DialogContextType {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    close: () => void;
}

export const DialogContext = createContext<DialogContextType | undefined>(undefined)

export function useDialogContext() {
    const context = useContext(DialogContext)
    if (!context) {
        throw new Error('Dialog compound components must be used within Dialog')
    }
    return context
}
